import React, { forwardRef, memo } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { COMPACT_BREAKPOINT } from '../../constants';
import Header from './header';
import type { PanelProps } from './types';

const Panel = forwardRef<HTMLDivElement, PanelProps>(
	({ title = '', onClose = noop, children }, ref) => (
		<Container
			data-test-id="software-backlog-panel.common.ui.panel.container"
			data-testid="software-backlog-panel.common.ui.panel.container"
		>
			<Header title={title} onClose={onClose} />
			<Content ref={ref}>{children}</Content>
		</Container>
	),
);

export { Panel };

export default memo(Panel);

const width = 220;
const widthLarge = 270;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'column',
	flexGrow: 1,
	paddingBottom: token('space.025', '2px'),
	boxSizing: 'border-box',
	borderRadius: '8px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface.sunken', colors.N20),
	alignSelf: 'start',
	maxHeight: `calc(100% - ${token('space.300', '24px')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${COMPACT_BREAKPOINT - 1}px)`]: {
		maxWidth: `${width}px`,
		width: `${width}px`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (min-width: ${COMPACT_BREAKPOINT}px)`]: {
		maxWidth: `${widthLarge}px`,
		width: `${widthLarge}px`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Content = styled.div({
	display: 'flex',
	flexDirection: 'column',
	flexGrow: 1,
	overflowX: 'hidden',
	overflowY: 'auto',
});
